import { CloseIcon, PictureIcon } from '@teamturing/icons';
import React from 'react';

import Image from '../../core/Image';
import Text from '../../core/Text';
import View from '../../core/View';

type Props = {
  title?: string;
  subText?: string;
  backgroundColor?: string;
  titleColor?: string;
  subTextColor?: string;
  imageUrl?: string | null;
};

const PromotionAppBannerPreview = ({
  title,
  subText,
  backgroundColor = '#F3F4F6',
  titleColor = '#33373B',
  subTextColor = '#7A828D',
  imageUrl,
}: Props) => {
  return (
    <View
      sx={{
        height: 148 * 0.67,
        transformOrigin: 'left top',
        transform: 'scale(0.67)',
      }}
    >
      <View
        height={148}
        borderRadius={15}
        backgroundColor={backgroundColor}
        position={'relative'}
        overflow={'hidden'}
        marginRight={`-${(100 / 67) * 33}%`}
      >
        <View
          height={148}
          width={148}
          backgroundColor={imageUrl ? 'transparent' : '#E5E7EB'}
          position={'absolute'}
          top={0}
          right={0}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          {imageUrl ? (
            <Image src={imageUrl} alt={imageUrl} html style={{ display: 'block' }} />
          ) : (
            <PictureIcon width={40} height={40} color={'#8D94A0'} />
          )}
        </View>
        <View padding={3} position={'relative'} display={'flex'} sx={{ columnGap: '12px' }}>
          <View flexGrow={1}>
            <View marginBottom={'2px'}>
              <Text fontWeight={500} fontSize={'14px'} color={subTextColor} lineHeight={1.5}>
                {subText || '서브 텍스트'}
              </Text>
            </View>
            <Text fontWeight={700} fontSize={'20px'} color={titleColor} lineHeight={1.5} whiteSpace={'pre-wrap'}>
              {title || '최대 2줄\n이미지에 안 겹치게'}
            </Text>
          </View>
          <View>
            <View padding={1}>
              <CloseIcon width={24} height={24} color={'white'} />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default PromotionAppBannerPreview;
export type { Props as IndexProps };
